module.exports = __webpack_public_path__ + "img/yichanggongdan.861b0c76.png";